import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import {Subject} from 'rxjs/Subject';
import {Config} from '../config';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class RoomsService {
  public backendUrl: any = new Config();

  constructor(private http: Http) { }

  getRoomsName(id) {
    return this.http.get(this.backendUrl.backendUrl + 'rooms/get-rooms-name/' + id).map(res => res.json());
  }

  getRoomsCats() {
    return this.http.get(this.backendUrl.backendUrl + 'rooms/get-all-roomsCats').map(res => res.json());
  }

  getRoom(bId, rId) {
    return this.http.get(this.backendUrl.backendUrl + 'rooms/get-room/' + bId + '/' + rId).map(res => res.json());
  }

  orderRoom(data) {
    return this.http.post(this.backendUrl.backendUrl + 'orders/add', data).map(res => res.json());
  }

  sendBookingEmail(data) {
    return this.http.post(this.backendUrl.backendUrl + 'orders/sendBookingEmail', data).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/services/rooms.service.ts